<template>
    <p class="p-m-0">Para hacer el cambio de su contraseña debe solicitar apoyo al personal de academica</p>
    <ul class="p-mt-2">
        <li>En la sede de UGB San Miguel</li>
        <li>En la sede de UGB Usulutan</li>
        <li>En el centro de atención en metrocentro San Miguel</li>
        <li>Llamando a Contact Center al número <b>2645-6500</b></li>
    </ul>
</template>

<script>
export default {
    name : 'CambiarClaveEstudiante'
}
</script>
